import React from 'react'
import {
  HeaderContainer,
  HeaderBackground,
  HeaderContent,
  HeaderTitle,
  HeaderSubtitle,
  HeaderDecoration,
  HeaderDecorationLeft,
  ProfilePictureContainer,
  ProfilePicture,
  ProfileInitials,
  AuthorName,
} from './styles'
import { DRAFT_BOARD_AUTHOR } from '../../../Constants/draft'

interface DraftBoardHeaderProps {
  title?: string
  subtitle?: string
  authorName?: string
  profilePicture?: string
  showProfilePicture?: boolean
}

export const DraftBoardHeader: React.FC<DraftBoardHeaderProps> = ({
  title = '2025 College Draft Big Board',
  subtitle = ' Official Draft Rankings ',
  authorName = DRAFT_BOARD_AUTHOR.name,
  profilePicture = DRAFT_BOARD_AUTHOR.profilePicture,
  showProfilePicture = true,
}) => {
  return (
    <HeaderContainer>
      <HeaderBackground>
        <HeaderDecoration />
        <HeaderDecorationLeft />
        <HeaderContent>
          {showProfilePicture && (
            <ProfilePictureContainer>
              {profilePicture ? (
                <ProfilePicture src={profilePicture} alt={authorName} />
              ) : (
                <ProfileInitials>AL</ProfileInitials>
              )}
            </ProfilePictureContainer>
          )}
          <AuthorName>{`${authorName}'s`}</AuthorName>
          <HeaderTitle>{title}</HeaderTitle>
          <HeaderSubtitle>{subtitle}</HeaderSubtitle>
        </HeaderContent>
      </HeaderBackground>
    </HeaderContainer>
  )
}
